import {
    GET_CONFIG_FORM32,
    GET_FECHAS,
    GET_COMBO_TIPO_GESTION,
    GET_COMBO_TIPO_ESTADO,
    GET_COMBO_SITUACION,
    GET_COMBO_TIPO_FECHA,
    GET_CONSULTA_CASOS,
    GET_EXCEL,
    CLEAN_CASOS,
    SET_QUERY_STATE
} from '../types';


export default function areaBusquedaCasosReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM32:
            return { ...state, cfg_form32:action.payload }
        case GET_FECHAS:
            return { ...state, fechas:action.payload }
        case GET_COMBO_TIPO_GESTION:
            return { ...state, comboTipoGestion:action.payload }
        case GET_COMBO_TIPO_ESTADO:
            return { ...state, comboEstado:action.payload }
        case GET_COMBO_SITUACION:
            return { ...state, comboSituacion:action.payload }
        case GET_COMBO_TIPO_FECHA:
            return { ...state, comboTipoFecha:action.payload }
        case GET_CONSULTA_CASOS:
            return { ...state, consultaCasos:action.payload }
        case GET_EXCEL:
            return { ...state, excel:action.payload }
        case CLEAN_CASOS:
            return { ...state, consultaCasos:{} }
        case SET_QUERY_STATE:
            return { ...state, myQueryStateGlobal:action.payload }
     
        
        
       
       
        default:
            return state
    }
}